import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
import { enablePush, getPushPermission, isPushSupported, } from '#pplx/frontend/push-notifications/pushNotifications.js';
const WEB_PUSH_RESTORE_MARKER_KEY = 'pplx.web-push.restore';
// The restore marker is per-browser (one Web Push subscription per ServiceWorker), not per-account,
// so it must stay un-namespaced under multi-account scope-by-default.
function hasRestoreMarker() {
    return SafeLocalStorage.getItem(WEB_PUSH_RESTORE_MARKER_KEY, { global: true }) === 'true';
}
/**
 * Persists the global marker that asks the app to restore web Push after a future sign-in.
 *
 * @returns Nothing.
 */
export function rememberPushForRestore() {
    SafeLocalStorage.setItem(WEB_PUSH_RESTORE_MARKER_KEY, 'true', { global: true });
}
/**
 * Clears the global marker that asks the app to restore web Push after sign-in.
 *
 * @returns Nothing.
 */
export function forgetPushForRestore() {
    SafeLocalStorage.removeItem(WEB_PUSH_RESTORE_MARKER_KEY, { global: true });
}
/**
 * Restores Push when the restore marker is present and notification permission is still granted.
 *
 * @param options - Restore options.
 * @param options.reason - Observability reason string passed through enable requests.
 * @returns `true` when Push is usable for this browser; otherwise `false`.
 */
export async function restorePush({ reason }) {
    if (!hasRestoreMarker())
        return false;
    if (!isPushSupported() || getPushPermission() !== 'granted') {
        return false;
    }
    return enablePush({ reason });
}
//# sourceMappingURL=pushNotificationsRestore.js.map